import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Phase 0 — installs `axios.defaults.withCredentials = true` globally so
// every axios call sends the HttpOnly mojo_session cookie. Imported here
// (before App) so the side-effect lands before any component runs.
import "@/lib/auth-client";
// Firebase init (Google Analytics). Side-effect import; no-ops until configured.
import "@/lib/firebase";
import App from "@/App";
// Phase 4 — register the service worker and start the offline-queue
// auto-flush loop. Both no-op in dev unless REACT_APP_ENABLE_SW=true.
import { registerServiceWorker } from "@/lib/sw-register";
import { startOfflineQueueAutoFlush } from "@/lib/offline-axios";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
startOfflineQueueAutoFlush();
